import { UserService } from '../../services';

export const generateGenericHeaderEntries = function(){
	
	return {
		'Content-Type': 'application/json',
	};
};

export const generateAuthHeaderEntries = function(){
	
	let token = UserService.getAuthToken();
	
	return ( token )
	       ? { ...generateAuthHeaderEntry( token ) }
	       : {}
};

export const generateAuthHeaderEntry = function( tokenValue: string ){
	
	return { 'Authorization': `Bearer ${ tokenValue }` }
};
